import { render, staticRenderFns } from "./VCalendario.vue?vue&type=template&id=362a5402&scoped=true"
import script from "./VCalendario.vue?vue&type=script&lang=js"
export * from "./VCalendario.vue?vue&type=script&lang=js"
import style0 from "./VCalendario.vue?vue&type=style&index=0&id=362a5402&prod&scoped=true&lang=css"
import style1 from "./VCalendario.vue?vue&type=style&index=1&id=362a5402&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362a5402",
  null
  
)

export default component.exports